package empiresmp.components.fade.animation

class Transition<T>(
    val instance: T,
    val animatable: Animatable = Animatable(0f)
)
